import './index.css'
import cn from 'clsx'
import { detect } from 'detect-browser'
import mobile from 'is-mobile'
import get from 'lodash/get'
import * as React from 'react'
const browser = detect()
const isMobile = mobile({
  tablet: true,
})
export default class BrowserModal extends React.Component<any> {
  render(): null | React.ReactElement<'div'> {
    if (isMobile) return null
    // browser can be null in Opera beta and possibly in some other browsers
    const safeVer = get(browser, 'version', '')
    const safeName = get(browser, 'name', null)
    const majorVersion = parseInt(safeVer.split('.')[0], 10)
    const isChrome = safeName === 'chrome'
    const isFirefox = safeName === 'firefox'
    const isOpera = safeName === 'opera'
    const isSafari9 = safeName === 'safari' && majorVersion >= 9
    const isUnknown = safeName === null
    if (isChrome || isSafari9 || isFirefox || isOpera || isUnknown) return null
    return (
      <div
        className={cn(`BrowserModal is-visible`, {
          'cookies-disabled': navigator && navigator.cookieEnabled,
        })}
      >
        <p>
          For best performance, please use the Chrome browser. <br />
          You can download it{' '}
          <a
            href="https://www.google.com/chrome/browser/desktop/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>
      </div>
    )
  }
}
